import React, { useState, Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './navbar.css'

const Navbar = (props) => {
  const [link5AccordionOpen, setLink5AccordionOpen] = useState(false)
  const [link5DropdownVisible, setLink5DropdownVisible] = useState(false)
  return (
    <header className={`navbar-container1 ${props.rootClassName} `}>
      <header
        data-thq="thq-navbar"
        className="navbar-thq-navbar-interactive-elm"
      >
        <Link to="/" className="navbar-navlink">
          <img
            alt={props.logoAlt}
            src={props.logoSrc}
            className="navbar-thq-image1-elm"
          />
        </Link>
        <div data-thq="thq-navbar-nav" className="navbar-thq-desktop-menu-elm">
          <nav className="navbar-thq-links-elm1">
            <Link
              to="/"
              className="navbar-thq-link1-elm thq-link thq-body-small"
            >
              {props.link1 ?? (
                <Fragment>
                  <span className="navbar-text23">Home</span>
                </Fragment>
              )}
            </Link>
            <a
              href={props.link2Url?.['url']}
              target={props.link2Url?.['newTab'] ? '_blank' : undefined}
              rel={
                props.link2Url?.['newTab'] ? 'noreferrer noopener' : undefined
              }
              className="thq-link thq-body-small"
            >
              {props.link2 ?? (
                <Fragment>
                  <span className="navbar-text19">Services</span>
                </Fragment>
              )}
            </a>
            <a
              href={props.link3Url?.['url']}
              target={props.link3Url?.['newTab'] ? '_blank' : undefined}
              rel={
                props.link3Url?.['newTab'] ? 'noreferrer noopener' : undefined
              }
              className="navbar-thq-link3-elm1 thq-link thq-body-small"
            >
              {props.link3 ?? (
                <Fragment>
                  <span className="navbar-text16">About Us</span>
                </Fragment>
              )}
            </a>
            <a
              href={props.link3Url1?.['url']}
              target={props.link3Url1?.['newTab'] ? '_blank' : undefined}
              rel={
                props.link3Url1?.['newTab'] ? 'noreferrer noopener' : undefined
              }
              className="navbar-thq-link3-elm2 thq-link thq-body-small"
            >
              {props.link31 ?? (
                <Fragment>
                  <span className="navbar-text13">About Us</span>
                </Fragment>
              )}
            </a>
          </nav>
          <div className="navbar-thq-buttons-elm1">
            <a
              href="tel:+380932979737"
              className="navbar-thq-action2-elm1 thq-button-animated thq-button-outline"
            >
              <span>
                {props.action2 ?? (
                  <Fragment>
                    <span className="navbar-text24">Call Now</span>
                  </Fragment>
                )}
              </span>
            </a>
          </div>
        </div>
        <div data-thq="thq-burger-menu" className="navbar-thq-burger-menu-elm">
          <svg viewBox="0 0 1024 1024" className="navbar-icon10">
            <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
        </div>
        <div data-thq="thq-mobile-menu" className="navbar-thq-mobile-menu-elm">
          <div className="navbar-thq-nav-elm">
            <div className="navbar-thq-top-elm">
              <img
                alt={props.logoAlt}
                src={props.logoSrc}
                className="navbar-thq-logo-elm"
              />
              <div
                data-thq="thq-close-menu"
                className="navbar-thq-close-menu-elm"
              >
                <svg viewBox="0 0 1024 1024" className="navbar-icon12">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
            </div>
            <nav className="navbar-thq-links-elm2">
              <a
                href={props.link2Url?.['url']}
                target={props.link2Url?.['newTab'] ? '_blank' : undefined}
                rel={
                  props.link2Url?.['newTab'] ? 'noreferrer noopener' : undefined
                }
                className="thq-link thq-body-small"
              >
                {props.link2 ?? (
                  <Fragment>
                    <span className="navbar-text19">Services</span>
                  </Fragment>
                )}
              </a>
              <a
                href={props.link3Url?.['url']}
                target={props.link3Url?.['newTab'] ? '_blank' : undefined}
                rel={
                  props.link3Url?.['newTab'] ? 'noreferrer noopener' : undefined
                }
                className="navbar-thq-link3-elm3 thq-link thq-body-small"
              >
                {props.link3 ?? (
                  <Fragment>
                    <span className="navbar-text16">About Us</span>
                  </Fragment>
                )}
              </a>
              <div className="navbar-thq-link4-accordion-elm">
                {link5AccordionOpen === true && (
                  <div className="navbar-container2">
                    <a
                      href={props.linkUrlPage1?.['url']}
                      target={
                        props.linkUrlPage1?.['newTab'] ? '_blank' : undefined
                      }
                      rel={
                        props.linkUrlPage1?.['newTab']
                          ? 'noreferrer noopener'
                          : undefined
                      }
                    >
                      <div className="navbar-thq-menu-item-elm1">
                        <img
                          alt={props.page1ImageAlt}
                          src={props.page1ImageSrc}
                          className="navbar-thq-page1-image-elm1"
                        />
                        <div className="navbar-thq-content-elm1">
                          <span className="navbar-thq-page1-elm1 thq-body-large">
                            {props.page1 ?? (
                              <Fragment>
                                <span className="navbar-text21">Home</span>
                              </Fragment>
                            )}
                          </span>
                          <span className="thq-body-small">
                            {props.page1Description ?? (
                              <Fragment>
                                <span className="navbar-text14">
                                  Welcome to Evac - Your 24/7 Towing Partner
                                </span>
                              </Fragment>
                            )}
                          </span>
                        </div>
                      </div>
                    </a>
                    <a
                      href={props.linkUrlPage2?.['url']}
                      target={
                        props.linkUrlPage2?.['newTab'] ? '_blank' : undefined
                      }
                      rel={
                        props.linkUrlPage2?.['newTab']
                          ? 'noreferrer noopener'
                          : undefined
                      }
                    >
                      <div className="navbar-thq-menu-item-elm2">
                        <img
                          alt={props.page2ImageAlt}
                          src={props.page2ImageSrc}
                          className="navbar-thq-page2-image-elm1"
                        />
                        <div className="navbar-thq-content-elm2">
                          <span className="navbar-thq-page2-elm1 thq-body-large">
                            {props.page2 ?? (
                              <Fragment>
                                <span className="navbar-text20">Services</span>
                              </Fragment>
                            )}
                          </span>
                          <span className="thq-body-small">
                            {props.page2Description ?? (
                              <Fragment>
                                <span className="navbar-text12">
                                  Our Comprehensive Towing Services
                                </span>
                              </Fragment>
                            )}
                          </span>
                        </div>
                      </div>
                    </a>
                    <a
                      href={props.linkUrlPage3?.['url']}
                      target={
                        props.linkUrlPage3?.['newTab'] ? '_blank' : undefined
                      }
                      rel={
                        props.linkUrlPage3?.['newTab']
                          ? 'noreferrer noopener'
                          : undefined
                      }
                    >
                      <div className="navbar-thq-menu-item-elm3">
                        <img
                          alt={props.page3ImageAlt}
                          src={props.page3ImageSrc}
                          className="navbar-thq-page3-image-elm1"
                        />
                        <div className="navbar-thq-content-elm3">
                          <span className="navbar-thq-page3-elm1 thq-body-large">
                            {props.page3 ?? (
                              <Fragment>
                                <span className="navbar-text17">About Us</span>
                              </Fragment>
                            )}
                          </span>
                          <span className="thq-body-small">
                            {props.page3Description ?? (
                              <Fragment>
                                <span className="navbar-text15">
                                  Learn More About Evac Towing Services
                                </span>
                              </Fragment>
                            )}
                          </span>
                        </div>
                      </div>
                    </a>
                    <a
                      href={props.linkUrlPage4?.['url']}
                      target={
                        props.linkUrlPage4?.['newTab'] ? '_blank' : undefined
                      }
                      rel={
                        props.linkUrlPage4?.['newTab']
                          ? 'noreferrer noopener'
                          : undefined
                      }
                    >
                      <div className="navbar-thq-menu-item-elm4">
                        <img
                          alt={props.page4ImageAlt}
                          src={props.page4ImageSrc}
                          className="navbar-thq-page4-image-elm1"
                        />
                        <div className="navbar-thq-content-elm4">
                          <span className="navbar-thq-page4-elm1 thq-body-large">
                            {props.page4 ?? (
                              <Fragment>
                                <span className="navbar-text18">Contact</span>
                              </Fragment>
                            )}
                          </span>
                          <span className="thq-body-small">
                            {props.page4Description ?? (
                              <Fragment>
                                <span className="navbar-text22">
                                  Get in Touch with Evac for Immediate
                                  Assistance
                                </span>
                              </Fragment>
                            )}
                          </span>
                        </div>
                      </div>
                    </a>
                  </div>
                )}
              </div>
            </nav>
            <div className="navbar-thq-buttons-elm2">
              <a
                href="tel:+380932979737"
                className="navbar-thq-action2-elm2 thq-button-outline"
              >
                <span>
                  {props.action2 ?? (
                    <Fragment>
                      <span className="navbar-text24">Call Now</span>
                    </Fragment>
                  )}
                </span>
              </a>
            </div>
          </div>
          <div className="navbar-thq-icon-group-elm">
            <a
              href="https://www.tiktok.com/@evac_vn?_t=ZM-8wMKjHDJasA&amp;_r=1"
              target="_blank"
              rel="noreferrer noopener"
              className="navbar-link1"
            >
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                className="navbar-icon14 thq-icon-x-small"
              >
                <path
                  d="M21.358 19.14q-8.833-.426-12.28 6.298c-3.446 6.725-.598 17.729 10.9 17.729c11.5 0 11.832-11.112 11.832-12.276V17.875q3.69 2.336 6.22 2.813q2.533.476 3.22.422v-6.476q-2.342-.282-4.05-1.076c-1.709-.794-5.096-2.997-5.096-6.226q.003.024 0-2.499h-7.118q-.031 23.724 0 26.058c.031 2.334-1.78 5.6-5.45 5.6c-3.672 0-5.483-3.263-5.483-5.367c0-1.288.443-3.155 2.272-4.538c1.085-.82 2.59-1.148 5.033-1.148z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3.833"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </a>
            <a
              href="https://youtube.com/@evac_vn?si=sPI6CfpJNjrOzvUd"
              target="_blank"
              rel="noreferrer noopener"
              className="navbar-link2"
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                className="navbar-icon16 thq-icon-x-small"
              >
                <path
                  d="M29.41 9.26a3.5 3.5 0 0 0-2.47-2.47C24.76 6.2 16 6.2 16 6.2s-8.76 0-10.94.59a3.5 3.5 0 0 0-2.47 2.47A36 36 0 0 0 2 16a36 36 0 0 0 .59 6.74a3.5 3.5 0 0 0 2.47 2.47c2.18.59 10.94.59 10.94.59s8.76 0 10.94-.59a3.5 3.5 0 0 0 2.47-2.47A36 36 0 0 0 30 16a36 36 0 0 0-.59-6.74M13.2 20.2v-8.4l7.27 4.2Z"
                  fill="currentColor"
                ></path>
              </svg>
            </a>
            <a
              href="https://www.instagram.com/evac_616?igsh=emNyeHM1Z255N3Az"
              target="_blank"
              rel="noreferrer noopener"
              className="navbar-link3"
            >
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="navbar-icon18 thq-icon-x-small"
              >
                <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
              </svg>
            </a>
          </div>
        </div>
        {link5DropdownVisible === true && (
          <div className="navbar-container3 thq-box-shadow">
            <div className="navbar-thq-link5-menu-list-elm">
              <a
                href={props.linkUrlPage1?.['url']}
                target={props.linkUrlPage1?.['newTab'] ? '_blank' : undefined}
                rel={
                  props.linkUrlPage1?.['newTab']
                    ? 'noreferrer noopener'
                    : undefined
                }
              >
                <div className="navbar-thq-menu-item-elm5">
                  <img
                    alt={props.page1ImageAlt}
                    src={props.page1ImageSrc}
                    className="navbar-thq-page1-image-elm2 thq-img-ratio-1-1"
                  />
                  <div className="navbar-thq-content-elm5">
                    <span className="navbar-thq-page1-elm2 thq-body-large">
                      {props.page1 ?? (
                        <Fragment>
                          <span className="navbar-text21">Home</span>
                        </Fragment>
                      )}
                    </span>
                    <span className="thq-body-small">
                      {props.page1Description ?? (
                        <Fragment>
                          <span className="navbar-text14">
                            Welcome to Evac - Your 24/7 Towing Partner
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </a>
              <a
                href={props.linkUrlPage2?.['url']}
                target={props.linkUrlPage2?.['newTab'] ? '_blank' : undefined}
                rel={
                  props.linkUrlPage2?.['newTab']
                    ? 'noreferrer noopener'
                    : undefined
                }
              >
                <div className="navbar-thq-menu-item-elm6">
                  <img
                    alt={props.page2ImageAlt}
                    src={props.page2ImageSrc}
                    className="navbar-thq-page2-image-elm2 thq-img-ratio-1-1"
                  />
                  <div className="navbar-thq-content-elm6">
                    <span className="navbar-thq-page2-elm2 thq-body-large">
                      {props.page2 ?? (
                        <Fragment>
                          <span className="navbar-text20">Services</span>
                        </Fragment>
                      )}
                    </span>
                    <span className="thq-body-small">
                      {props.page2Description ?? (
                        <Fragment>
                          <span className="navbar-text12">
                            Our Comprehensive Towing Services
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </a>
              <a
                href={props.linkUrlPage3?.['url']}
                target={props.linkUrlPage3?.['newTab'] ? '_blank' : undefined}
                rel={
                  props.linkUrlPage3?.['newTab']
                    ? 'noreferrer noopener'
                    : undefined
                }
              >
                <div className="navbar-thq-menu-item-elm7">
                  <img
                    alt={props.page3ImageAlt}
                    src={props.page3ImageSrc}
                    className="navbar-thq-page3-image-elm2 thq-img-ratio-1-1"
                  />
                  <div className="navbar-thq-content-elm7">
                    <span className="navbar-thq-page3-elm2 thq-body-large">
                      {props.page3 ?? (
                        <Fragment>
                          <span className="navbar-text17">About Us</span>
                        </Fragment>
                      )}
                    </span>
                    <span className="thq-body-small">
                      {props.page3Description ?? (
                        <Fragment>
                          <span className="navbar-text15">
                            Learn More About Evac Towing Services
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </a>
              <a
                href={props.linkUrlPage4?.['url']}
                target={props.linkUrlPage4?.['newTab'] ? '_blank' : undefined}
                rel={
                  props.linkUrlPage4?.['newTab']
                    ? 'noreferrer noopener'
                    : undefined
                }
              >
                <div className="navbar-thq-menu-item-elm8">
                  <img
                    alt={props.page4ImageAlt}
                    src={props.page4ImageSrc}
                    className="navbar-thq-page4-image-elm2 thq-img-ratio-1-1"
                  />
                  <div className="navbar-thq-content-elm8">
                    <span className="navbar-thq-page4-elm2 thq-body-large">
                      {props.page4 ?? (
                        <Fragment>
                          <span className="navbar-text18">Contact</span>
                        </Fragment>
                      )}
                    </span>
                    <span className="thq-body-small">
                      {props.page4Description ?? (
                        <Fragment>
                          <span className="navbar-text22">
                            Get in Touch with Evac for Immediate Assistance
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        )}
      </header>
      {link5DropdownVisible === true && (
        <div
          onClick={() => setLink5DropdownVisible(false)}
          className="navbar-container4"
        ></div>
      )}
    </header>
  )
}

Navbar.defaultProps = {
  page2Description: undefined,
  link3Url1: {
    url: 'https://www.teleporthq.io',
    newTab: false,
  },
  link31: undefined,
  page1Description: undefined,
  page3ImageSrc:
    'https://images.unsplash.com/photo-1524448789231-1bb0771e7d45?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDd8fHJvdW5kfGVufDB8fHx8MTcxNjM5OTM0NHww&ixlib=rb-4.0.3&w=1400',
  linkUrlPage4: {
    url: 'https://www.teleporthq.io',
    newTab: false,
  },
  page3ImageAlt: 'Team at Evac Towing Services',
  page4ImageAlt: 'Contact Us Image',
  page3Description: undefined,
  page2ImageSrc:
    'https://images.unsplash.com/photo-1618034100983-e1d78be0dc80?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDE3fHxyb3VuZHxlbnwwfHx8fDE3MTYzOTkzNDR8MA&ixlib=rb-4.0.3&w=1400',
  rootClassName: '',
  link3: undefined,
  page3: undefined,
  linkUrlPage3: {
    url: 'https://www.teleporthq.io',
    newTab: false,
  },
  page4: undefined,
  linkUrlPage2: {
    url: 'https://www.teleporthq.io',
    newTab: false,
  },
  link2: undefined,
  link2Url: {
    url: 'https://www.teleporthq.io',
    newTab: false,
  },
  page2: undefined,
  linkUrlPage1: {
    url: 'https://www.teleporthq.io',
    newTab: false,
  },
  page1ImageAlt: 'Evac Towing Services Logo',
  link3Url: {
    url: 'https://www.teleporthq.io',
    newTab: false,
  },
  page1: undefined,
  page4Description: undefined,
  logoAlt: 'Evac Towing Services',
  link1: undefined,
  page1ImageSrc:
    'https://images.unsplash.com/photo-1514285490982-4130e9aefedb?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDF8fHJvdW5kfGVufDB8fHx8MTcxNjM5OTM0NHww&ixlib=rb-4.0.3&w=1400',
  page4ImageSrc:
    'https://images.unsplash.com/photo-1605745141160-8892dc674e94?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDI0fHxyb3VuZHxlbnwwfHx8fDE3MTYzOTkzNDR8MA&ixlib=rb-4.0.3&w=1400',
  logoSrc:
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/84ec08e8-34e9-42c7-9445-d2806d156403/fac575ac-7a41-484f-b7ac-875042de11f8?org_if_sml=1&force_format=original',
  action2: undefined,
  page2ImageAlt: 'Towing Truck',
}

Navbar.propTypes = {
  page2Description: PropTypes.element,
  link3Url1: PropTypes.object,
  link31: PropTypes.element,
  page1Description: PropTypes.element,
  page3ImageSrc: PropTypes.string,
  linkUrlPage4: PropTypes.object,
  page3ImageAlt: PropTypes.string,
  page4ImageAlt: PropTypes.string,
  page3Description: PropTypes.element,
  page2ImageSrc: PropTypes.string,
  rootClassName: PropTypes.string,
  link3: PropTypes.element,
  page3: PropTypes.element,
  linkUrlPage3: PropTypes.object,
  page4: PropTypes.element,
  linkUrlPage2: PropTypes.object,
  link2: PropTypes.element,
  link2Url: PropTypes.object,
  page2: PropTypes.element,
  linkUrlPage1: PropTypes.object,
  page1ImageAlt: PropTypes.string,
  link3Url: PropTypes.object,
  page1: PropTypes.element,
  page4Description: PropTypes.element,
  logoAlt: PropTypes.string,
  link1: PropTypes.element,
  page1ImageSrc: PropTypes.string,
  page4ImageSrc: PropTypes.string,
  logoSrc: PropTypes.string,
  action2: PropTypes.element,
  page2ImageAlt: PropTypes.string,
}

export default Navbar
